import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SpecSettingsProvider } from './contexts/SpecSettingsContext';
import { BootGate } from './components/boot/BootGate';
import { AnnaWall } from './pages/AnnaWall';
import { SpecStyle } from './pages/SpecStyle';
import { CommandCenter } from './pages/CommandCenter';
import { Telefoon } from './pages/Telefoon';
import { Logboek } from './pages/beheer/Logboek';
import { Agents } from './pages/beheer/Agents';
import { Geheugen } from './pages/beheer/Geheugen';
import { Huis } from './pages/beheer/Huis';
import { Systeem } from './pages/beheer/Systeem';
import { AnnaSettings } from './pages/beheer/AnnaSettings';
interface AppProps {
  /** Signature accent proposal: luminous teal or warm gold */
  accent?: 'teal' | 'gold';
  /** How expressive Anna's micro-behaviours are: gaze, blinks, sighs, perk-ups */
  aliveness?: 'calm' | 'lively';
  /** Play the "anna → orb" boot sequence on first load of the session */
  bootAnimation?: boolean;
}
export function App({
  accent = 'teal',
  aliveness = 'lively',
  bootAnimation = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3mjzpgvevclx2">
      <SpecSettingsProvider accent={accent} aliveness={aliveness} data-id="element-1" data-mp="3mj6ipufwtwex">
        <BootGate enabled={bootAnimation} data-id="element-2" data-mp="3rcsxpt9jqcdw">
          <Routes data-id="element-3" data-mp="5yi8qe3h5da">
            <Route path="/" element={<AnnaWall data-id="element-5" data-mp="4n4pyuukj8z" />} data-id="element-4" data-mp="6hq1ea16ddl" />
            <Route path="/bureau" element={<CommandCenter data-id="element-7" data-mp="2zld0z6e9z99y" />} data-id="element-6" data-mp="82lr78302d1" />
            <Route path="/telefoon" element={<Telefoon data-id="element-9" data-mp="2zmwlj96ys6hj" />} data-id="element-8" data-mp="2zm4wyibsb90r" />
            <Route path="/spec" element={<SpecStyle data-id="element-11" data-mp="33lx02fiesmyq" />} data-id="element-10" data-mp="33mowfsjtyoq2" />
            <Route path="/beheer" element={<Navigate to="/beheer/logboek" replace data-id="element-13" data-mp="33oi152avuyvf" />} data-id="element-12" data-mp="33n6xd2hftr4b" />
            <Route path="/beheer/logboek" element={<Logboek data-id="element-15" data-mp="38o4ercumih4r" />} data-id="element-14" data-mp="38l05i12awv78" />
            <Route path="/beheer/agents" element={<Agents data-id="element-17" data-mp="3dmfq5s0kgzp3" />} data-id="element-16" data-mp="3dle2mo2d6kqh" />
            <Route path="/beheer/geheugen" element={<Geheugen data-id="element-19" data-mp="nw2c461hdqr3" />} data-id="element-18" data-mp="3dirvgpjdy78s" />
            <Route path="/beheer/huis" element={<Huis data-id="element-21" data-mp="nxwwnj8ubgun" />} data-id="element-20" data-mp="nur8c681cizz" />
            <Route path="/beheer/systeem" element={<Systeem data-id="element-23" data-mp="stc6m03q8sls" />} data-id="element-22" data-mp="sudlygrs019b" />
            <Route path="/beheer/anna" element={<AnnaSettings data-id="element-25" data-mp="35yq6nee9s31" />} data-id="element-24" data-mp="swqaxdvybbvv" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" data-mp="34ndfy2z19zs" />} data-id="element-26" data-mp="356t1855fman" />
          </Routes>
        </BootGate>
      </SpecSettingsProvider>
    </BrowserRouter>;
}